import { standardSchemaResolver } from "@hookform/resolvers/standard-schema";

export const appSchemaResolver = standardSchemaResolver;
